import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useFetchData from "../../../../repo/get";

const Pagination = () => {
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pagina = parseInt(searchParams.get("pagina"), 10) || 1;
  const dateAnterior = searchParams.get("dateAnterior") || "";
  const dateAntes = searchParams.get("dateAntes") || "";
  const entregadorIdFromUrl = searchParams.get("entregadorId") || "";

  const baseSelect = localStorage.getItem("baseSelected") || "";
  const cargoSelect = localStorage.getItem("cargo") || "";

  // Filtro de entregadores
  const { data: fetchedData } = useFetchData("api/entregadores/findAll");

  // Usamos useState para controlar os filtros (datas e entregador)
  const [filters, setFilters] = useState({
    dateAnterior: dateAnterior,
    dateAntes: dateAntes,
    entregadorId: entregadorIdFromUrl,
  });

  // Monta a query para a API considerando os filtros
  const queryParams =
  `${filters.dateAnterior ? `?dateAnterior=${filters.dateAnterior}` : ""}` +
  `${filters.dateAntes ? `${filters.dateAnterior ? "&" : "?"}dateAntes=${filters.dateAntes}` : ""}` +
  `${filters.entregadorId ? `${(filters.dateAnterior || filters.dateAntes) ? "&" : "?"}entregadorId=${filters.entregadorId}` : (cargoSelect === "ENTREGADOR" ? `${(filters.dateAnterior || filters.dateAntes) ? "&" : "?"}entregadorId=${localStorage.getItem("id")}` : "")}`;

  const { data: totalPages } = useFetchData(
    `api/romaneios/getFinishedAllPages/${baseSelect}${queryParams}`
  );

  const handlePageChange = (id) => {
    const { dateAnterior, dateAntes, entregadorId } = filters;
    history.push(
      `/admin/logistica/recebidos?pagina=${id}` +
      `${dateAnterior ? `&dateAnterior=${dateAnterior}` : ""}` +
      `${dateAntes ? `&dateAntes=${dateAntes}` : ""}` +
      `${entregadorId ? `&entregadorId=${entregadorId}` : ""}`
    );
  };

  // Função genérica para atualizar filtros (funciona tanto para inputs de data quanto para o select de entregadores)
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const formatDateForApi = (date, isEndDate = false) => {
    if (!date) return "";
    const formattedDate = new Date(date);
    const year = formattedDate.getFullYear();
    const month = String(formattedDate.getMonth() + 1).padStart(2, '0');
    const day = String(formattedDate.getDate()).padStart(2, '0');

    const hours = isEndDate ? '23' : '00';
    const minutes = '59';
    const seconds = '59';

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  };

  const renderPageNumbers = () => {
    const start = Math.max(1, pagina - 1);
    const end = Math.min(totalPages, pagina + 1);

    return (
      <div className="flex items-center justify-center space-x-2 mt-4">
        {pagina > 1 && (
          <button
            className="px-4 py-2 rounded-lg bg-gray-300 hover:bg-gray-400 text-gray-700"
            onClick={() => handlePageChange(pagina - 1)}
          >
            &laquo; Anterior
          </button>
        )}

        {start > 1 && (
          <>
            <button
              key={1}
              className={`px-4 py-2 rounded-lg ${pagina === 1 ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'}`}
              onClick={() => handlePageChange(1)}
            >
              1
            </button>
            {start > 2 && <span key="ellipsis" className="px-4 py-2 text-gray-700">...</span>}
          </>
        )}

        {Array.from({ length: end - start + 1 }, (_, i) => start + i).map((pageNumber) => (
          <button
            key={pageNumber}
            className={`px-4 py-2 rounded-lg ${pagina === pageNumber ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'}`}
            onClick={() => handlePageChange(pageNumber)}
          >
            {pageNumber}
          </button>
        ))}

        {end < totalPages && (
          <>
            <span key="ellipsis-end" className="px-4 py-2 text-gray-700">...</span>
            <button
              key={totalPages}
              className={`px-4 py-2 rounded-lg ${pagina === totalPages ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'}`}
              onClick={() => handlePageChange(totalPages)}
            >
              {totalPages}
            </button>
          </>
        )}

        {pagina < totalPages && (
          <button
            className="px-4 py-2 rounded-lg bg-gray-300 hover:bg-gray-400 text-gray-700"
            onClick={() => handlePageChange(pagina + 1)}
          >
            Próxima &raquo;
          </button>
        )}
      </div>
    );
  };

  return (
    <div>
      {/* Filtros */}
      <div className="flex flex-col md:flex-row justify-between items-center w-full">
        <div className="flex flex-col m-4">
          <label htmlFor="dateAnterior" className="text-sm font-medium text-gray-700">Data Anterior</label>
          <input
            type="datetime-local"
            name="dateAnterior"
            value={filters.dateAnterior ? formatDateForApi(filters.dateAnterior) : ""}
            onChange={handleFilterChange}
            className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="flex flex-col m-4">
          <label htmlFor="dateAntes" className="text-sm font-medium text-gray-700">Data Antes</label>
          <input
            type="datetime-local"
            name="dateAntes"
            value={filters.dateAntes ? formatDateForApi(filters.dateAntes, true) : ""}
            onChange={handleFilterChange}
            className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Filtro de Entregadores */}
        

        {/* Botões de Filtro */}
        <div className="ml-auto flex m-4">
          <button
            onClick={() => handlePageChange(1)}
            className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition duration-200"
          >
            Pesquisar
          </button>
          <button
            onClick={() => setFilters({ dateAnterior: "", dateAntes: "", entregadorId: "" })}
            className="px-6 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition duration-200"
          >
            Limpar Pesquisa
          </button>
        </div>
      </div>
      <div className="flex flex-col m-4">
          <label htmlFor="entregadorId" className="text-sm font-medium text-gray-700">Entregador</label>
          <select
            name="entregadorId"
            value={filters.entregadorId}
            onChange={handleFilterChange}
            className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Todos</option>
            {fetchedData &&
              fetchedData.map((entregador) => (
                <option key={entregador.id} value={entregador.id}>
                  {entregador.nome}
                </option>
              ))}
          </select>
        </div>

      {/* Paginação */}
      {renderPageNumbers()}
    </div>
  );
};

export default Pagination;
